import React, { memo, useState, useCallback } from 'react';
import { toastr } from 'react-redux-toastr';
import Loading from 'xpi-black-ui/Base/Loading';
import Page from 'xpi-black-ui/Base/Page';
import { Row } from 'xpi-black-ui/Base/Grid';
import { H1 } from 'xpi-black-ui/Base/Typography';
import Text from 'xpi-black-ui/Base/Typography/Text';
import Dropdown from 'xpi-black-ui/Common/Dropdown';

import useUnwindingProposalCenter from 'store/ProposalCenter/queries/useUnwindingProposalCenter';
import useProposalCenterStore from 'store/ProposalCenter/state';

import BlackContainer from 'components/Common/BlackContainer';
import UnwindingProposalFilter from '../../components/Filters/UnwindingProposalFilter';
import GenericTableBox from '../../components/Generics/GenericTableBox';
import UnwindingProposalTable from '../../components/Tables/UnwindingProposalTable';
import UnwindingProposalDialog from '../../components/Dialogs/UnwindingProposalDialog';

import WrapperTable from './styles';


const DEFAULT_FILTERED_OPTIONS_STATE = {
  Status: [],
  ProposalDates: [],
  AdvisorCodes: [],
  Clients: [],
  Tickers: [],
  Structures: [],
  OperationType: [],
};

function UnwindingProposalCenterPage() {
  const { getProposalsReport } = useProposalCenterStore();
  const [isLoading, setIsLoading] = useState(false);
  const [isOpenTableUnwindingProposalDialog, setIsOpenTableUnwindingProposalDialog] = useState(false);
  const [proposalSelected, setProposalSelected] = useState(undefined);
  const [pagination, setPagination] = useState({ currentPage: 1, totalPages: 0 });
  const [filteredOptions, setFilteredOptions] = useState(DEFAULT_FILTERED_OPTIONS_STATE);

  const {
    proposals,
    filters,
    totalPages,
    isLoading: filterIsLoading,
    refetchUnwinding,
  } = useUnwindingProposalCenter(
    pagination.currentPage,
    filteredOptions,
  );

  const onPageChange = useCallback(({ currentPage }) => {
    setPagination(oldState => ({ ...oldState, currentPage }));
  }, [filteredOptions]);

  const onOpenTableDialog = useCallback((proposal) => {
    setProposalSelected(proposal);
    setIsOpenTableUnwindingProposalDialog(true);
  }, []);

  const onCloseTableDialog = useCallback(() => {
    setProposalSelected(undefined);
    setIsOpenTableUnwindingProposalDialog(false);
  }, []);

  const downloadReport = (response) => {
    const file = new Blob([response], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    const a = document.createElement('a');
    document.body.appendChild(a);
    const url = window.URL.createObjectURL(file);
    a.href = url;
    a.download = 'PropostasAntecipacao';
    a.click();
  };

  const onGetReport = useCallback((Filters) => {
    setIsLoading(true);

    const NEW_FILTERS = Filters ? { ...Filters } : undefined;

    getProposalsReport({
      Filters: NEW_FILTERS,
    }).then((response) => {
      const { data, status } = response;
      if (status === 200) {
        if (data.byteLength > 0) {
          downloadReport(data);
        } else {
          toastr.info('Nenhum registro encontrado', 'Ops...');
        }
      } else {
        toastr.error('Erro ao carregar o relatório', 'Ops...');
      }
    }).catch((error) => {
      const errorMessage = error.response.data?.errorMessages[0] ?? 'Não foi possível exportar a lista de propostas.';

      toastr.error('Ops...', errorMessage);
    }).finally(() => setIsLoading(false));
  }, []);

  const renderNoContent = () => (
    <Text>Nenhuma proposta foi encontrada.</Text>
  );

  return (
    <BlackContainer>
      <Page>
        {(isLoading || filterIsLoading) && <Loading text="Carregando..." fixed />}

        <UnwindingProposalFilter
          onFilter={filterData => setFilteredOptions(oldState => ({ ...oldState, ...filterData }))}
          onClear={filterData => setFilteredOptions(oldState => ({ ...oldState, ...filterData }))}
          options={filters}
          filterNames={[
            { name: 'status', size: 75 },
            { name: 'proposalDates', size: 200 },
            { name: 'advisorCodes', size: 125 },
            { name: 'clients', size: 200 },
            { name: 'tickers', size: 200 },
            { name: 'structures', size: 125 },
            { name: 'operationType', size: 75 },
          ]}
        />

        <WrapperTable>
          <Row justifyContent="space-between" align="baseline" border>
            <H1 noMargin>
              Central de Propostas - Antecipações e Novas contratações
            </H1>
            {proposals?.length > 0
              && (
                <Dropdown
                  title="Exportar"
                  items={[
                    { text: 'Excel',
                      link: () => {
                        onGetReport(filteredOptions);
                      } },
                  ]}
                />
                )
            }
          </Row>

          {!isLoading && proposals?.length === 0 && renderNoContent()}
          {!isLoading && proposals?.length > 0
            && (
            <GenericTableBox
              onUpdate={() => refetchUnwinding()}
              updating={filterIsLoading}
              title="Lista de Propostas"
              pagination={{
                onPageChange,
                currentPage: pagination.currentPage,
                totalPages,
              }}
            >
              <UnwindingProposalTable
                onOpenDetails={onOpenTableDialog}
                data={proposals}
                refetch={() => refetchUnwinding()}
              />

              <UnwindingProposalDialog
                onClose={onCloseTableDialog}
                proposal={proposalSelected}
                isOpen={isOpenTableUnwindingProposalDialog}
              />

            </GenericTableBox>
            )
          }
        </WrapperTable>
      </Page>
    </BlackContainer>
  );
}

export default memo(UnwindingProposalCenterPage);
